import ComponentsCollection from '../../../general/js/components-collection';
import contentBlocker from '../../../general/js/content-blocker';
import NavComponent from './nav.component';
import HeaderSearchComponent from './header-search.component';
import BaseComponent from '../../../general/js/base-component';
import eventBus from '../../../general/js/event-bus';
import {EVENT_DEVICE_TYPE_CHANGED, DEVICE_TYPE_DESKTOP} from '../../../general/js/app';
import {EVENT_OUTER_CLICK} from './header-events';

export default class HeaderComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.menuBtn = this.refs.menuBtn;
        this.navTriggers = this.refs.navTriggers;
        this.isMenuOpened = false;

        this.onDeviceTypeChanged = this.onDeviceTypeChanged.bind(this);

        this.init();
    }

    static getRequiredRefs() {
        return ['menuBtn', 'navTriggers'];
    }

    init() {
        ComponentsCollection.getInstance().createComponent(this.element, 'search', HeaderSearchComponent, {
            onOpen: this.onSearchOpen.bind(this),
        });

        this.navComponent = ComponentsCollection.getInstance().createComponent(this.element, 'nav', NavComponent, {
            triggers: this.navTriggers
        });

        this.menuBtn.addEventListener('click', this.onMenuButtonClick.bind(this));

        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
        this.trackOuterClick();
    }

    onDeviceTypeChanged(oldType, newType) {
        //switch from tablet/mobile to desktop
        //we have to close burger menu properly
        if (newType === DEVICE_TYPE_DESKTOP && this.isMenuOpened) {
            this.closeMenu();
        }
    }

    onMenuButtonClick() {
        if (!this.isMenuOpened) {
            this.openMenu();
        } else {
            this.closeMenu();
        }
    }

    openMenu() {
        this.isMenuOpened = true;
        contentBlocker.block('menu');
        this.element.classList.add('is-menu-opened');
    }

    closeMenu() {
        this.isMenuOpened = false;
        this.element.classList.remove('is-menu-opened');
        contentBlocker.unblock('menu');
    }

    //when the search starts to open we need close navs and then open the search
    onSearchOpen(searchComponent) {
        if (this.navComponent) {
            this.navComponent.reset().then(() => {
                searchComponent.open();
            });
        }
    }

    trackOuterClick() {
        document.addEventListener('click', ({target}) => {
            if (!this.element.contains(target)) {
                eventBus.emit(EVENT_OUTER_CLICK);
            }
        })
    }
}



// WEBPACK FOOTER //
// ./app/components/header/js/header.component.js